const _ = "cardWrapper_aK4e-", t = "standalone_SKg4t", a = "stampCard_JdHnM", s = "stampCard__scanCode_0AhSt", r = "stampCard__profile_YJgzz", e = "stampCard__profile__tierName_A0-u1", m = "stampCard__profile__customerName_ceAAM", d = "stampCard__status_2ffL2", o = "stampCard__status__details_-p-J9", p = "stampCard__status__details__currencyName_ND4sA", c = "stampCard__status__expiration_P5xss", l = "stampCard__wallet__disabled_6nP8k", n = "stampCard__footNote_fMhzs", C = "terms_wL7xI", i = "terms__modal_e4NnX", u = "terms__block_P5z3x", f = "terms__title_p-z-x", N = "terms__text_mbHC8", x = {
  cardWrapper: _,
  standalone: t,
  stampCard: a,
  stampCard__scanCode: s,
  stampCard__profile: r,
  stampCard__profile__tierName: e,
  stampCard__profile__customerName: m,
  stampCard__status: d,
  stampCard__status__details: o,
  stampCard__status__details__currencyName: p,
  stampCard__status__expiration: c,
  stampCard__wallet__disabled: l,
  stampCard__footNote: n,
  terms: C,
  terms__modal: i,
  terms__block: u,
  terms__title: f,
  terms__text: N
};
export {
  _ as cardWrapper,
  x as default,
  a as stampCard,
  n as stampCard__footNote,
  r as stampCard__profile,
  m as stampCard__profile__customerName,
  e as stampCard__profile__tierName,
  s as stampCard__scanCode,
  d as stampCard__status,
  o as stampCard__status__details,
  p as stampCard__status__details__currencyName,
  c as stampCard__status__expiration,
  l as stampCard__wallet__disabled,
  t as standalone,
  C as terms,
  u as terms__block,
  i as terms__modal,
  N as terms__text,
  f as terms__title
};
//# sourceMappingURL=stampCard.module.scss.js.map
